<template>
  <div class="out_box">
    <!-- <div class="toolout_box">
      <div class="tool_content" @click="openDialog">
        <div>新建图裂变任务</div>
        <div class="tool_btm">
          <span style="margin-right: 8px;">上传图片</span>
          <span>从我的素材资产库选取</span>
        </div>
      </div>
    </div> -->
    <div class="temp_t">
      <div class="temp_t_btn" @click="openDialog">新增任务</div>
      <div class="aiwork_headform">
        <el-date-picker
          v-model="searchTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
        <el-input v-model="searchForm.batch_number" placeholder="批次"></el-input>
        <el-select v-model="searchForm.user_id" placeholder="请选择" v-if="userRole.key != 'employee'">
          <el-option
            v-for="item in subAccountList"
            :key="item.id"
            :label="`${item.nickname}${item.id == $store.state.userInfo.id ? '(我)' : ''}`"
            :value="item.id">
          </el-option>
        </el-select>
        <el-button class="search_btn" @click="tableSearch">搜索</el-button>
      </div>
    </div>
    <el-table
      :data="tableData"
      class="main_table">
      <el-table-column
        prop="batch_number"
        label="批次">
        <template slot-scope="scope">
          <div class="exceedomit">{{ scope.row.remarks }}</div>
          <div>{{ scope.row.batch_number }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="date"
        label="模式" />
      <el-table-column
        prop="size"
        label="尺寸比例" /> -->
      <el-table-column
        label="任务数量">
        <template slot-scope="scope">
          任务数量：{{scope.row.num}}
          <el-divider direction="vertical"></el-divider>
          <span :style="{color: scope.row.completed_num ? '#3FBF72' : '#A6A6A6'}">完成数量：{{scope.row.completed_num}}</span> 
        </template>
      </el-table-column>
      <el-table-column
        label="任务进度">
        <template slot-scope="scope">
          <el-progress :percentage="parseInt((scope.row.completed_num / scope.row.num) * 100)" :color="percentColors"></el-progress>
        </template>
      </el-table-column>
      <el-table-column
        label="状态">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 0" class="table_type2">已取消</div>
          <div v-else>
            <div v-if="scope.row.completed_num == 0" class="table_type1">未生成</div>
            <div v-else-if="scope.row.completed_num / scope.row.num < 0.5" class="table_type3">
              生成中
            </div>
            <div v-else-if="scope.row.completed_num / scope.row.num < 0.75" class="table_type3">
              生成中
            </div>
            <div v-else-if="scope.row.completed_num / scope.row.num == 1" class="table_type4">
              完成
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="version"
        label="类型">
        <template slot-scope="scope">
          {{ scope.row.version == '1.0' ? '平铺' : '模特' }}
        </template>
      </el-table-column>
      <el-table-column prop="user.nickname" label="用户" />
      <el-table-column
        prop="create_time"
        label="创建时间" />
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="toDetail(scope.row.id)">查看详情</el-button>
          <el-button type="text" v-if="scope.row.status == 1 && scope.row.completed_num != scope.row.num" @click="handleCancel(scope.row.id)">终止任务</el-button>
          <!-- <el-button type="text" disabled>下载</el-button> -->
          <el-button slot="reference" type="text" v-if="userInfo.id == scope.row.user.id" @click="toRemark(scope.row)">备注</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="main_pagination"
      @current-change="handleCurrentChange"
      background
      layout="prev, pager, next"
      :page-size="searchForm.limit"
      :total="tableTotal">
    </el-pagination>
    <el-drawer
      class="main_drawer"
      size="40.5%"
      title="新建图裂变任务"
      :visible.sync="addDrawer"
      direction="rtl"
      :show-close="false"
      :wrapperClosable="false">
      <div class="main_drawer_body">
        <el-form label-position="left" hide-required-asterisk label-width="106px" :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item label="新建参考素材" class="position_top" label-width="100%" prop="images">
            <el-upload
              accept=".jpg, .jpeg, .png, .gif, .webp"
              ref="uploadRef"
              class="form-uploader"
              action
              drag
              multiple
              :show-file-list="false"
              :auto-upload="false"
              :on-change="handleUploadImg"
              :disabled="uploadLoading">
              <div class="uploader_c" v-loading="uploadLoading">
                <div v-if="ruleForm.images.length || uploadQueue.length"> 
                  已选择{{ruleForm.images.length + uploadQueue.length}}张图片
                  <span v-if="failedFiles.length > 0" class="failed-count">
                    ({{ failedFiles.length }} 张上传失败)
                  </span>
                </div>
                <div>
                  <el-dropdown @command="uploadChangeType">
                    <span class="el-dropdown-link upload_btns" style="margin-right: 8px;" @click.stop>
                      {{(ruleForm.images.length || uploadQueue.length) ? '继续上传' : '上传图片'}}
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="image">上传图片</el-dropdown-item>
                      <el-dropdown-item command="folder">上传文件夹</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <span class="upload_btns" @click.stop="openMaterialDialog">从我的素材资产库选取</span>
                </div>
                <div class="upload_tips">将文件/文件夹拖放到此处，建议不超过100张</div>
              </div>
            </el-upload>
          </el-form-item>
          <!-- <el-form-item label="尺寸比例：" prop="size">
            <el-select v-model="ruleForm.size" placeholder="请选择">
              <el-option label="1024 * 1024" value="1024*1024"></el-option>
              <el-option label="1280 * 720" value="1280*720"></el-option>
              <el-option label="720 * 1280" value="720*1280"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="图片相似度：" prop="ref_strength">
            <el-slider v-model="ruleForm.ref_strength" :min="0" :max="1" :step="0.1" show-input :show-input-controls="false"></el-slider>
          </el-form-item>
          <el-form-item label="生成数量：" prop="num">
            <el-radio-group v-model="ruleForm.num" size="mini" style="margin-top: 10px;">
              <el-radio border :label="item" v-for="item in 4">{{item}}张</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="版本：" prop="version">
            <el-radio-group v-model="ruleForm.version" size="mini" style="margin-top: 10px;">
              <el-radio label="1.0">平铺</el-radio>
              <el-radio label="2.0">模特</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="main_drawer_footer">
        <el-button class="drawer_confirm" @click="handleSubmit">
          立 即 生 成 
          <span class="expend_num" v-if="beanNum">(消耗{{beanNum}}积分)</span>
        </el-button>
        <el-button class="drawer_cancel" @click="addDrawer = false">取 消</el-button>
      </div>
    </el-drawer>
    <SelectMaterial ref="selectMaterialRef" @handleSelect="handleMaterialSelect" />
  </div>
</template>
<script>
import { aiGetList, aiCreate, aiGetTaskNum, aiRemark, aiGetBeansConfig, aiDelete } from '@/api/imgAndText'
import { templateUploadImage } from '@/api/template'
import { allSubGetList } from '@/api/subaccount'

import SelectMaterial from '@/components/SelectMaterial'
export default {
  name: "figures",
  components: {SelectMaterial},
  data () {
   return {
    searchTime: [],
    subAccountList: [{id: -1, nickname: '全部'}],
    searchForm: {
      type: 'graph_fission',
      batch_number: '',
      start_time: '',
      end_time: '',
      page: 1,
      limit: 10
    },
    tableData: [],
    tableTotal: 0,
    percentColors: [
      {color: '#FF5733', percentage: 50},
      {color: '#A5D63F', percentage: 75},
      {color: '#3FBF72', percentage: 100},
    ],
    refreshTimer: null,

    addDrawer: false,
    uploadLoading: false,
    uploadQueue: [],
    uploadedCount: 0,
    batchNo: 0,
    currentBatch: [],
    failedFiles: [],
    ruleForm: {
      type: 'graph_fission',
      images: [],
      ref_strength: 0.4,
      num: 1,
      version: '1.0'
    },
    rules: {
      images: [{ required: true, message: '请上传图片', trigger: 'blur' }],
    },

    beansConfig: null,
  }
  },
  created() {
    if(this.userRole.key != 'employee') {
      this.$set(this.searchForm, 'user_id', -1)
    }
    this.getSubList()
    this.getAiList()
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
    userRole() {
      return this.$store.getters.userRole
    },
    beanNum() {
      let initial = this.beansConfig?.beans
      let iscoutimg = this.beansConfig?.per_image
      if(iscoutimg) {
        let imglen = this.ruleForm.images.length
        initial = imglen * initial
      }

      return initial * this.ruleForm.num || 0
    }
  },
  beforeDestroy() {
    if(this.refreshTimer) {
      clearTimeout(this.refreshTimer);
      this.refreshTimer = null;
    }
  },
  methods:{
    openDialog() {
      this.addDrawer = true
      this.ruleForm.images = []
      this.ruleForm.ref_strength = 0.4
      this.ruleForm.num = 1
      this.ruleForm.version = '1.0'
      aiGetBeansConfig('graph_fission').then(res => {
        this.beansConfig = res.data
      })
    },
    toDetail(id) {
      this.$router.push({
        path: '/toolbox/figures3/detail',
        query: {id}
      })
    },
    toRemark(row) {
      var _this = this;
      let remarkContent = row.remarks || '';
      this.$prompt('', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        inputPlaceholder: '请输入备注',
        inputType: 'textarea',
        inputValue: remarkContent,
        inputAttributes: { rows: 5 }
      }).then(({ value }) => {
        aiRemark({type: 'graph_fission', task_id: row.id, remarks: value}).then(res => {
          _this.$message.success('备注成功');
          _this.getAiList()
        })
      }).catch(() => {
      });
    },
    handleCancel(id) {
      this.$confirm('是否终止该任务?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        aiDelete(id).then(res => {
          this.getAiList()
          this.$message.success('任务终止成功');
        })
      })
    },
    openMaterialDialog() {
      let ref = this.$refs.selectMaterialRef
      ref.dialogMaterialVisible = true
    },
    handleMaterialSelect(data) {
      this.ruleForm.images = this.ruleForm.images.concat(data)
    },
    uploadChangeType(type) {
      if(type == 'folder') {
        this.$refs.uploadRef.$children[0].$refs.input.webkitdirectory = true;
      }else {
        this.$refs.uploadRef.$children[0].$refs.input.webkitdirectory = false;
      }
      this.$refs.uploadRef.$refs["upload-inner"].handleClick();
    },
    handleUploadImg(file, fileList) {
      // 将文件添加到上传队列
      this.uploadQueue.push({
        id: file.uid,
        file: file.raw,
        name: file.name,
        size: file.size,
        status: 'pending', // pending, uploading, success, error
        retryCount: 0
      });

      if(!this.uploadLoading) {
        this.uploadStart()
      }
      // this.uploadLoading = true
      // const formdata = new FormData()
      // formdata.append('image', param.file)
      // templateUploadImage(formdata).then(res => {
      //   this.ruleForm.images.push({url: res.data.url})
      //   this.uploadLoading = false
      // })
    },
    async uploadStart() {
      if (this.uploadQueue.length === 0) {
        this.$message.warning('没有文件需要上传');
        return;
      }
      this.uploadLoading = true;

      while(this.uploadQueue.length > 0) {
        this.currentBatch = this.uploadQueue.splice(0, 10)
        this.batchNo++;
        
        await this.uploadBatch(this.currentBatch);

        this.uploadedCount += this.currentBatch.length

        // console.log('当前第' + this.batchNo + '批次，批次数组：', this.currentBatch, 'this.uploadedCount', this.uploadedCount);
      }

      // 上传完成
      this.uploadComplete();

    },
    /**
     * 上传单个批次
     */
    async uploadBatch(batch) {
      // 为批次中的每个文件创建上传Promise
      const uploadPromises = batch.map(item => 
        this.uploadSingleFile(item.file).catch(error => {
          this.failedFiles.push(item)
          console.error(`文件 ${item.name} 上传失败:`, error);
          // 这里可以记录失败，但继续上传其他文件
          return null;
        })
      );

      // 等待当前批次的所有文件上传完成 
      await Promise.all(uploadPromises);
    },
    
    /**
     * 上传单个文件
     */
    async uploadSingleFile(file) {
      const formdata = new FormData();
      formdata.append('image', file);
      
      try {
        const res = await templateUploadImage(formdata, this.processCallback);
        this.ruleForm.images.push({url: res.data.url});

        return res;
      } catch (error) {
        console.log('uploaderror', error);
        
        throw error;
      }
    },
    processCallback(progressEvent) {
      // el-upload 如果是手动上传无法使用on-progress监听
      // progress.loaded表示当前上传的数据大小，progress.total表示整个要上传的数据大小
      // | 通常不用于逻辑判断，而是用于底层位操作，如设置标志位、取整
      let complete = progressEvent.loaded / progressEvent.total * 100 | 0;
      console.log('complete', complete, progressEvent, progressEvent.loaded, progressEvent.total);
      
    },
    /**
     * 上传完成
     */
    uploadComplete() {
      // 重置状态
      this.uploadLoading = false;
      this.uploadQueue = [];
      this.uploadedCount = 0;
      this.batchNo = 0;
      
      // 显示完成提示
      this.$message.success(`上传完成，共上传 ${this.ruleForm.images.length} 张图片`);
      
      // 清空upload组件的文件列表
      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.clearFiles();
      }
    },
    refreshTaskNum(id, cmnum) {
      aiGetTaskNum(id).then(res => {
        if(res.data[id].completed_num == res.data[id].num) {

        }else {
          if(res.data[id].status) {
            this.refreshTimer = setTimeout(() => {
              this.refreshTaskNum(id, res.data[id].completed_num)
            }, 8000);
          }
        }
        if(cmnum != res.data[id].completed_num) {
          this.tableData.forEach(item => {
            if(item.id == id) {
              item.completed_num = res.data[id].completed_num
            }
          })
        }
      })
    },
    handleSubmit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          aiCreate(this.ruleForm).then(res => {
            this.$store.dispatch("USER_INFO");
            this.$message.success('创建任务成功')
            this.addDrawer = false
            this.getAiList()
            this.refreshTaskNum(res.data.task_id, 0)
          })
        }
      })
    },
    tableSearch() {
      if(this.searchTime && this.searchTime.length) {
        this.searchForm.start_time = this.searchTime[0]
        this.searchForm.end_time = this.searchTime[1]
      }else {
        this.searchForm.start_time = ''
        this.searchForm.end_time = ''
      }
      this.searchForm.page = 1
      this.getAiList()
    },
    handleCurrentChange(val){
      this.searchForm.page = val
      this.getAiList()
    },
    getAiList() {
      aiGetList(this.searchForm).then(res => {
        this.tableData = res.data.list
        this.tableTotal = res.data.total
      })
    },
    getSubList() {
      allSubGetList().then(res => {
        this.subAccountList = this.subAccountList.concat(res.data)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.out_box {
  border-radius: 8px;
  background: #FFFFFF;
  padding: 24px 16px;
  .temp_t {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    .temp_t_btn {
      border-radius: 8px;
      background: linear-gradient(90deg, #132632 0%, #3E4B4F 100%);
      font-size: 20px;
      font-weight: 500;
      color: #F7F8FA;
      width: 171px;
      height: 48px;
      text-align: center;
      line-height: 48px;
      cursor: pointer;
    }
  }
  .toolout_box {
    border-radius: 8px;
    background: linear-gradient(90deg, rgba(168, 209, 255, 0.15) 0%, rgba(168, 209, 255, 0) 100%);
    color: #fff;
    font-size: 16px;
    padding: 16px;
    .tool_content {
      padding: 34px;
      text-align: center;
      border-radius: 4px;
      color: #F8FC00;
      font-size: 20px;
      border: 1px dashed transparent;
      // 实线部分 5px，透明间隔 5px（总和 10px 为一个周期）
      border-image: repeating-linear-gradient(
        45deg,
        rgba(236, 239, 44, .6) 0,
        rgba(236, 239, 44, .6) 3px,  /* 实线部分长度控制 */
        transparent 3px,  /* 间隔开始 */
        transparent 6px /* 间距控制 */
      ) 2; /* 2是border-width的值 */
      cursor: pointer;
      .tool_btm {
        margin-top: 12px;
        span {
          display: inline-block;
          color: #737373;
          font-size: 12px;
          padding: 4px 8px;
          background: #292929;
          border-radius: 2px;
          line-height: 24px;
        }
      }
    }
  }
  .exceedomit {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .table_type1, .table_type2, .table_type3, .table_type4 {
    width: 60px;
    height: 20px;
    text-align: center;
    line-height: 17px;
    font-size: 12px;
    border-radius: 4px;
  }
  .table_type1 {
    color: #333333;
    background: rgba(191, 191, 191, 0.3);
    border: 1px solid #BFBFBF;
  }
  .table_type2 {
    color: #FF5733;
    background: rgba(255, 87, 51, 0.35);
    border: 1px solid #FF5733;
  }
  .table_type3 {
    color: #729E13;
    background: rgba(165, 214, 63, 0.35);
    border: 1px solid #A5D63F;
  }
  .table_type4 {
    color: #3EC775;
    background: rgba(179, 252, 209, 0.3);
    border: 1px solid #3FBF72;
  }
  .form-uploader {
    /deep/ .el-upload {
      width: 100%;
      .el-upload-dragger {
        border-radius: 8px;
        // background: #FFFFFF;
        padding: 16px;
        width: 100%;
        // border: none;
        .uploader_c {
          border-radius: 4px;
          // padding: 33px;
          border: 1px dashed #bfbfbf;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
      }
    }
    .upload_btns{
      display: inline-block;
      border-radius: 2px;
      padding: 4px 8px;
      border: 1px solid #acaf0b;
      font-size: 12px;
      color: #acaf0b;
      line-height: 24px;
    }
    .upload_tips {
      color: #8C8C8C;
      margin-top: 16px;
      line-height: 16px;
    }
  }
}
</style>